import script from "./GitConfigDeleteModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./GitConfigDeleteModal.vue?vue&type=script&setup=true&lang=ts"

import "./GitConfigDeleteModal.vue?vue&type=style&index=0&id=6dfa93d4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dfa93d4"]])

export default __exports__